import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrlApi } from "../../proxy";
import axios from "axios";

interface MobilePayload {
  mobile?: string;
  email?: string;
  whatsapp?: string;
}

export const getRecaptchaKey = createAsyncThunk(
  "login/getRecaptchaKey",
  async () => {
    try {
      const response = await axios.get(`${baseUrlApi}recaptcha/keys`);
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
);

export const toLogin = createAsyncThunk(
  "login/toLogin",
  async (mobile: MobilePayload) => {
    try {
      const response = await axios.post(`${baseUrlApi}login`, mobile);
      return response;
    } catch (error) {
      throw error;
    }
  }
);
